module.exports = __webpack_public_path__ + "18358326c569c5d7584a6000ad4c87bf.svg";